import styles from "./Contact.module.css";

const contacts = [
  {
    href: "https://wa.me/94765851400",
    label: "WhatsApp Us",
    logo: "/whatsapp-logo.png",
    className: "whatsapp",
    target: "_blank",
  },
  {
    href: "https://instagram.com/ratnapuragems",
    label: "Instagram",
    logo: "/instagram-logo.png",
    className: "instagram",
    target: "_blank",
  },
  {
    href: "tel:0765851400",
    label: "076 585 1400",
    emoji: "📞",
    className: "call",
    target: "_self",
  },
];

export default function Contact() {
  return (
    <section id="contact" className={styles.section}>
      <div className={styles.inner}>
        <p className={styles.eyebrow}>Get In Touch</p>
        <h2 className={styles.title}>Begin Your Journey</h2>
        <p className={styles.body}>
          Whether you're looking for the perfect gift, a custom design, or your
          dream engagement ring, we're here to make it unforgettable.
        </p>

        <div className={styles.btnGroup}>
          {contacts.map(({ href, label, logo, emoji, className, target }) => (
            <a
              key={label}
              href={href}
              target={target}
              rel="noreferrer"
              className={`${styles.btn} ${styles[className]}`}
            >
              {logo ? (
                <img src={logo} alt={label} width={22} height={22} className={styles.logo} />
              ) : (
                <span>{emoji}</span>
              )}
              {label}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}